<template>
    <Top :show-user="true"/>
    <div class='analytics-container' v-if="dates.length > 0">
      <AnalyticsDataBlock
        :link='"portfolio-analytics/direct"' 
        :groups="groups" 
        :dates="dates"
        :title="'Прямой бизнес'"
        :multiTitles="true"
        :portfolioView="true"
      />
      <AnalyticsDataBlock 
        :link='"portfolio-analytics/reinsurance"' 
        :groups="groups" 
        :dates="dates"
        :title="'Перестрахование'"
        :multiTitles="true"
        :portfolioView="true"
      />
    </div>
</template>


<script>
import Top from "@/components/Top";
import AnalyticsFilter from "@/components/Analytics/AnalyticsFilter";
import AnalyticsDataBlock from "@/components/Analytics/AnalyticsDataBlock";

export default {
  name: 'PortfolioAnalytics',
  components: {
    Top,
    AnalyticsFilter,
    AnalyticsDataBlock
  },
  data(){
    return {
      groups: [],
      dates: [],
    }
  },
  methods: {
    loadReports() {
      this.$http
        .get('/reports')
        .then(response => {
          const reports = response.data
          this.dates = this.getData(reports).reportDates
          this.groups = this.getData(reports).groups
          console.log('loadReports: data is loaded')
        })
        .catch(error => console.error('loadReports: ERROR: ' + error))
    },
    getData(items){
      const data = {}
      data.reportDates = [...new Set(items.map(report => {
        return report.report_date
      }))]
      data.groups = items.map(report => {
        return {id: report.group, name: report.group_name}
      })
      data.groups = [...new Map(data.groups.map(item => [item['id'], item])).values()]
      return data
    },
  },
  mounted(){
    this.loadReports()
  },
}
</script>

<style scoped>
.analytics-container{
  margin-top: 5.2rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

</style>